module.exports = __webpack_public_path__ + "img/coeur_plein.3c8b0a8c.png";